function updateStoreFieldValues(result, props) {
  let objectKeys = Object.keys(result);
  if (result[objectKeys[0]].result) {
    props.connectedForm.dispatch(props.connectedForm.change(false, result[objectKeys[0]].result));
  }
}

export default updateStoreFieldValues;
